import { FC } from "react";
import AppTooltip from "../tooltip";
import { Link } from "react-router-dom";

interface ITableDataTooltip {
  tableData?: any;
  tooltipData?: any;
  tooltipPlacement?: any;
  wrapperClassname?: any;
  AppTooltipClassName?: any;
  linkUrl?: string;
  target?: string;
}

/**
 * Table Data Tooltip Reusable Component
 *
 * @param {{ tableData: any; tooltipData: any; tooltipPlacement: any; wrapperClassname: any; AppTooltipClassName: any; }} param0
 * @param {*} param0.tableData
 * @param {*} param0.tooltipData
 * @param {*} param0.tooltipPlacement
 * @param {*} param0.wrapperClassname
 * @param {*} param0.AppTooltipClassName
 * @returns {*}
 */

const TableDataTooltip: FC<ITableDataTooltip> = ({
  tableData,
  tooltipData,
  tooltipPlacement,
  wrapperClassname,
  AppTooltipClassName,
  linkUrl,
  target,
}) => {
  return (
    <AppTooltip
      title={tooltipData ?? tableData}
      placement={tooltipPlacement ?? "top"}
      className={AppTooltipClassName}
    >
      {linkUrl ? (
        <Link
          className={`mw-100 d-inline-block text-truncate align-middle ${wrapperClassname ?? ""}`}
          to={linkUrl}
          target={target}
        >
          {tableData}
        </Link>
      ) : (
        <span
          className={`align-middle d-inline-block mw-100 text-truncate ${wrapperClassname ?? ""}`}
        >
          {tableData}
        </span>
      )}
    </AppTooltip>
  );
};

export default TableDataTooltip;
